import React, { useState } from 'react';
import { AppContextProvider, ControlContextProvider } from './components/hooks/context';
import StageApp from './StageApp';
import ControlApp from './ControlApp';
import { modelMaskProps, modelRawMaskProps } from './components/helpers/Interfaces';
import StageVideoApp from './StageVideoApp';
import ControlVideoApp from './ControlVideoApp';

// dog
// const IMAGE_PATH1 = "/assets/data/dog.jpg";
// const IMAGE_PATH2 = "/assets/data/dog.jpg";
// const IMAGE_EMBEDDING = "/assets/data/dog_embedding.npy";

// dogs
// const IMAGE_PATH1 = "/assets/data/dogs.jpg";
// const IMAGE_PATH2 = "/assets/data/dogs.jpg";
// const IMAGE_EMBEDDING = "/assets/data/dogs_embedding.npy";

// truck
// const IMAGE_PATH1 = "/assets/data/truck.jpg";
// const IMAGE_PATH2 = "/assets/data/truck.jpg";
// const IMAGE_EMBEDDING = "/assets/data/truck_embedding.npy";

// groceries
const IMAGE_PATH1 = "/assets/data/groceries.jpg";
const IMAGE_PATH2 = "/assets/data/truck.jpg";
const IMAGE_EMBEDDING = "/assets/data/groceries_embedding_fast.npy";

// 000
// const IMAGE_PATH1 = "/assets/data/000.png";
// const IMAGE_PATH2 = "/assets/data/001.png";
// const IMAGE_EMBEDDING = "/assets/data/000_embedding.npy";

const App = () => {
  const [masks, setMasks] = useState<Array<modelMaskProps>>([]);
  const [defaultRawMask, setDefaultRawMask] = useState<modelRawMaskProps | null>(null);
  const [blocking, setBlocking] = useState<boolean>(false);
  const addMask = (mask: modelMaskProps) => {
    setMasks([...masks, mask]);
  }

  const [imagePath1, setImagePath1] = useState<string>("http://10.6.8.70:5001/uploads/003fd24d-d75c-4941-9d9c-1468bb0eedb2.png");
  const [imagePath2, setImagePath2] = useState<string>("http://10.6.8.70:5001/uploads/08bc1c5f-6e01-434e-bc34-1fd3c2c38002.png");
  const [videoPath, setVideoPath] = useState<string>("")
  
  const [uploadType, setUploadType] = useState<boolean>(true); // false: image, true: video

  const handleDeleteMask = (index: number) => {
    const newMasks = [...masks];
    newMasks.splice(index,1)
    setMasks(newMasks);
  };

  const updateLoader = (loading: boolean) => {
    setBlocking(loading)
  }

  const updateMasks = (masks: Array<modelMaskProps>) => {
    console.log("vatran updateMasks", "")
    setMasks(masks);
  }
  const [fitWidth, setFitWidth] = useState<boolean>(true);

  const flexCenterClasses = "flex items-center justify-center m-auto";
  return (
    <>  
      <div className="w-full h-full">
        <h1 className="text-center text-2xl my-3">Manipulated Interpolation of Anything      
        {/* <a href='https://github.com/zzh-tech/InterpAny-Clearer' target='_blank'><i className="fa fa-github githerf"></i></a>    */}
          {/* <a href='https://github.com/OpenGVLab' target='_blank'><i className='gvlabherf'>OpenGVLab</i></a> */}
          </h1>  
          <h1 className="text-center text-2xl my-3">   <a href='https://github.com/zzh-tech/InterpAny-Clearer' target='_blank'><i className="fa fa-github githerf"></i></a>   
          <a href='https://github.com/OpenGVLab' target='_blank'><i className='fa fa-home gvlabherf'>  OpenGVLab</i></a>
          </h1>  
        <div className={`${flexCenterClasses} w-[90%] h-[90%]`}>
          {!uploadType && <AppContextProvider>
            <StageApp setDefaultRawMask={setDefaultRawMask} addMask={addMask} updateLoader={updateLoader} onUploadImage1={setImagePath1} onUploadImage2={setImagePath2} 
            onSetType={setUploadType} uploadType={uploadType}/>
          </AppContextProvider>}
          {uploadType && <StageVideoApp updateLoader={updateLoader} onSetType={setUploadType} uploadType={uploadType} onUploadVideo={setVideoPath}  onFitWidth={setFitWidth}/>}

          {!uploadType && <ControlContextProvider>
            <ControlApp defaultRawMask={defaultRawMask} masks={masks} handleDelete={handleDeleteMask} updateMasks={updateMasks} updateLoader={updateLoader}
              image1Path={imagePath1} image2Path={imagePath2} />
          </ControlContextProvider>}
          {uploadType && <ControlVideoApp  updateLoader={updateLoader}  videoPath={videoPath} shouldFitWidth={fitWidth}/>}
        </div>
      </div>
      
      <div className={blocking? 'flex model' : 'hidden' }>
        <div className='modal-content'>
          <div className='loader'></div>
          <div className='modal-text'>Loading...</div>
        </div>
      </div>
    </>
  );
}

export default App;